var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.activePanelNotInitialPanel)?_c('div',[(_vm.loading)?_c('div',[_c('dd-loading-indicator',{staticStyle:{"height":"80vh"}})],1):(_vm.dynamicComponent)?_c('div',[_c(_vm.dynamicComponent,{tag:"component"})],1):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }